export const CLEAR_SORT_OPTION_ID = 'CLEAR_SORT';

export const SortOptionsSupport = [
    { id: 'HEADER', label: 'Tempo de criação', header: true },
    {
        id: 'CREATED_ASC',
        label: 'Mais antigo primeiro',
        icon: <span className='rioglyph rioglyph-sort' />,
    },
    {
        id: 'CREATED_DESC',
        label: 'Mais recente primeiro',
        icon: <span className='rioglyph rioglyph-sort' />,
    },
    { id: 'HEADER', label: 'Tempo na etapa', header: true },
    {
        id: 'STATUS_UPDATED_AT_DESC',
        label: 'Menor tempo primeiro',
        icon: <span className='rioglyph rioglyph-sort' />,
    },
    {
        id: 'STATUS_UPDATED_AT_ASC',
        label: 'Maior tempo primeiro',
        icon: <span className='rioglyph rioglyph-sort' />,
    },
    { id: 'HEADER', label: '__________________________', header: true },
    {
        id: CLEAR_SORT_OPTION_ID,
        label: 'Limpar ordenação',
        icon: <span className='rioglyph rioglyph-trash' />,
    },
];

const SORT_BY_TO_API: Record<string, string> = {
    CREATED: 'createdAt',
    STATUS_UPDATED_AT: 'statusUpdatedAt',
};

const SORT_BY_FROM_API: Record<string, string> = {
    createdAt: 'CREATED',
    statusUpdatedAt: 'STATUS_UPDATED_AT',
};

export const parseSortOption = (optionId: string) => {
    const lastUnderscore = optionId.lastIndexOf('_');
    const sortByKey = optionId.substring(0, lastUnderscore);
    const sortDirection = optionId.substring(lastUnderscore + 1);

    return {
        sortBy: SORT_BY_TO_API[sortByKey] ?? sortByKey,
        sortDirection,
    };
};

export const getSortOptionId = (sortBy: string, sortDirection: string) => {
    if (!sortBy || !sortDirection) return '';
    const sortByKey = SORT_BY_FROM_API[sortBy] ?? sortBy;
    return `${sortByKey}_${sortDirection}`;
};
